module.exports = __webpack_public_path__ + "fonts/iconfont.1d69a150.ttf";